const bucket = import.meta.env.VITE_REACT_APP_STORAGE_BUCKET?.toString() || ''

const region = 'eu-west-1'

export const submissionImageUrl = (fileName: string) => {
  return `https://${bucket}.s3.${region}.amazonaws.com/submissions/${fileName}`
}
